function FileManager() {
  return (
    <>
      <h1 style={{ margin: "0 auto" }}>File Manager</h1>
    </>
  );
}

export default FileManager;
